import React, { useState, useEffect } from 'react';
// components
import ModalSetImg from './ModalSetImg';

const ImgUpload = ({ outputsEl, node, index, callbackFromParent }) => {
    // state
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isOverflowModal, setOverflowModal] = useState(false);

    // 모달 열기
    const openModal = () => {
        let ItemSetButtonPos = node.current.getBoundingClientRect();
        let contentsWrap = node.current.offsetParent.offsetParent.getBoundingClientRect();
        if (contentsWrap.right - ItemSetButtonPos.right < 241) {
            setOverflowModal(true);
        }
        setIsOpenModal(!isOpenModal);
    };
    // 모달 닫기 (이거 왜 안에 넣었지??ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ큐ㅠㅠ)
    useEffect(() => {
        const closeSet = (e) => {
            if (node.current.contains(e.target)) {
                // inside click
                return;
            }
            setIsOpenModal(false);
        };

        // add when mounted
        document.addEventListener('mousedown', closeSet);
        // return function to be called when unmounted
        return () => {
            document.removeEventListener('mousedown', closeSet);
        };
    }, [node]);

    // 이미지  url
    let bgImgUrl = outputsEl.simpleImage.imageUrl;
    // 이미지  url 콜백
    const changeImgUrl = (imgUrl) => {
        bgImgUrl = imgUrl;

        let imgObj = {
            simpleImage: {
                imageUrl: bgImgUrl,
                altText: '',
            },
            index: index,
        };
        callbackFromParent(imgObj);
    };
    // 버튼 백그라운드 이미지
    const btnBgStyle = {
        backgroundImage: `url(${bgImgUrl})`,
    };

    return (
        <>
            <button
                type="button"
                style={btnBgStyle}
                onClick={openModal}
                className="simple"
            >
                {bgImgUrl === '' && '+ 이미지 등록 '}
                {!bgImgUrl && <span>*</span>}
                <img src={bgImgUrl} alt="" />
            </button>
            {isOpenModal && (
                <ModalSetImg
                    outputsEl={outputsEl}
                    changeImgUrl={changeImgUrl}
                    isOverflowModal={isOverflowModal}
                    isCarousel={false}
                />
            )}
        </>
    );
};

export default ImgUpload;
